const play = `<svg viewBox="0 0 10 11.8125461">
    <g stroke="currentColor" stroke-width="1" stroke-linejoin="round" fill="none">
        <g transform="translate(0.5, 0.5008)">
            <polygon points="9 5.406 4.5 8.108 0 10.811 0 0 4.49903867 2.703 9 5.405"></polygon>
        </g>
    </g>
</svg>`
export default play